var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageAlignmentLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.675C3 3.30221 3.30221 3 3.675 3C4.04779 3 4.35 3.30221 4.35 3.675V20.325C4.35 20.6978 4.04779 21 3.675 21C3.30221 21 3 20.6978 3 20.325V3.675Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 6C22.5 5.17157 21.8284 4.5 21 4.5H9C8.17157 4.5 7.5 5.17157 7.5 6V18C7.5 18.8284 8.17157 19.5 9 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18V6ZM9.75 6C9.33579 6 9 6.33579 9 6.75V17.25C9 17.6642 9.33579 18 9.75 18H20.25C20.6642 18 21 17.6642 21 17.25V6.75C21 6.33579 20.6642 6 20.25 6H9.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7494 12C13.9921 12 14.9994 10.9926 14.9994 9.75C14.9994 8.50736 13.9921 7.5 12.7494 7.5C11.5068 7.5 10.4994 8.50736 10.4994 9.75C10.4994 10.9926 11.5068 12 12.7494 12ZM12.7494 10.5C13.1636 10.5 13.4994 10.1642 13.4994 9.75C13.4994 9.33579 13.1636 9 12.7494 9C12.3352 9 11.9994 9.33579 11.9994 9.75C11.9994 10.1642 12.3352 10.5 12.7494 10.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1938 10.2921C18.9075 9.9927 18.4328 9.98205 18.1334 10.2683L8.25 18.9027L9.74991 19.5L18.6279 11.8708L21 14.25L22.0842 13.2134L19.1938 10.2921Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageAlignmentLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image-alignment-left.a3e454b85d4af8eb2022e11d30fda249.svg";